import { ZONES_ACTIONS } from './zones.types'

/**
 * @param {Object.<string, import('./zones.types').Zone>} payload
 * @returns {Object}
 */
export const setZonesAction = payload => ({
  type: ZONES_ACTIONS.SET_ZONES,
  payload
})

/**
 * @param {import('./zones.types').Zone} payload
 * @returns {Object}
 */
export const setZoneAction = payload => ({
  type: ZONES_ACTIONS.SET_ZONE,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setZonesStatusAction = payload => ({
  type: ZONES_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setZonesErrorsAction = payload => ({
  type: ZONES_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearZonesErrorsAction = () => ({
  type: ZONES_ACTIONS.CLEAR_ERRORS
})

/**
 * @param {string} payload - Zone ID
 * @returns {Object}
 */
export const removeZoneAction = payload => ({
  type: ZONES_ACTIONS.REMOVE_ZONE,
  payload
})
